import React from 'react';
import { Text, View } from 'react-native';
import MyAppText from '../../components/MyAppText';
import { translate } from '../../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../services/window-information';

interface TooltipModalProps {
  title: string;
  subTitle?: string;
  bodyTitle?: string;
  bodyItems?: string[];
}

export default function TableTooltip({ title, subTitle, bodyTitle, bodyItems }: TooltipModalProps) {
    const { styles, theme } = useStyles(stylesheet);
    const windowInfo = WindowInformation();

    return (
        <View style={styles.tooltipContainer(windowInfo.isMobile)}>
            <MyAppText style={styles.tooltipTitle}>{translate(title)}</MyAppText>
            {subTitle && <MyAppText style={styles.tooltipSubTitle}>{translate(subTitle)}</MyAppText>}

            <View>
                {bodyTitle && <MyAppText style={styles.bodyTitle}>{translate(bodyTitle)}:</MyAppText>}
                <View style={{ flexDirection: 'column', rowGap: 16 }}>
                    {bodyItems?.map((item, i) => (
                        <View key={i} style={{ }}>
                            <View style={{ flexDirection: 'row', gap: 8, alignItems: 'flex-start' }}>
                                <View style={{ width: 5, height: 5, marginTop: 8, borderRadius: 9999, backgroundColor: theme.colors.neutral['400'] }}/>
                                <MyAppText style={{ color: theme.colors.neutral['400'] }}>
                                    <Text style={styles.itemName}>
                                        {translate(item)}:
                                    </Text>
                                    <Text style={styles.itemDescription}>
                                        {translate(`${item}Description`)}
                                    </Text>
                                </MyAppText>
                            </View>
                        </View>
                    ))}
                </View>
            </View>
        </View>
    );
}

const stylesheet = createStyleSheet(theme => ({
    tooltipContainer: (isMobile: boolean) => ({
        flexDirection: 'column',
        rowGap: 12,
        backgroundColor: theme.colors.card.background,
        padding: 12,
        zIndex: 9999,
        borderRadius: 8,
        borderTopLeftRadius: isMobile ? 8 : 0,
        shadowColor: '#000',
        shadowOpacity: 0.45,
        shadowOffset: {
            height: -2,
            width: 2
        },
        shadowRadius: 10,
    }),
    tooltipTitle: {
        fontWeight: '700',
        fontSize: 14,
        color: theme.colors.neutral['500']
    },
    tooltipSubTitle: {
        fontWeight: '500',
        fontSize: 12,
        color: theme.colors.neutral['400']
    },
    bodyTitle: {
        fontWeight: '700',
        fontSize: 12,
        color: theme.colors.neutral['400']
    },
    itemName: {
        fontWeight: '700',
        fontSize: 12,
        marginRight: 4,
    },
    itemDescription: {
        fontWeight: '500',
        fontSize: 12,
    },
}));
